import { render, staticRenderFns } from "./thickness.vue?vue&type=template&id=5c435cb5&scoped=true&"
import script from "./thickness.vue?vue&type=script&lang=js&"
export * from "./thickness.vue?vue&type=script&lang=js&"
import style0 from "./thickness.vue?vue&type=style&index=0&id=5c435cb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c435cb5",
  null
  
)

component.options.__file = "thickness.vue"
export default component.exports